export default __webpack_public_path__ + "static/media/c001-general2024-4.ca0dddba.png";